export const tableHeaders = ["#", "Creator", "APR", "TVL", "Fee", "My Stake", ""];

export const URL = window.location.origin + "/";

export const defaultUserProfile = {
    name: "Anonymous",
    imageUrl: "/assets/default.svg",
    description: "No Description Provided",
    walletAddress: "0x0000000000000000000000000000000000000"
};
export const EXPLORER_URL = "https://etherscan.io/tx/";
export const PROJECT_ID =  'f114388f7181c9cc683b750db8419b74'

export const GRAPH_API_KEY = "33cd3cda553318f4f5d18c4dd98566a6";


// Helper function to detect if user rejected the signing request
export const isUserRejectionError = (error) => {
    if (!error) return false;

    const errorMessage = error.message?.toLowerCase() || '';
    const errorCode = error.code;

    // Common rejection patterns across different wallets
    const rejectionPatterns = [
        'user rejected',
        'user denied',
        'user declined',
        'rejected',
        'denied',
        'cancelled',
        'abort',
        '4001', // MetaMask rejection code
        '-32603', // Internal JSON-RPC error (often used for rejections)
    ];

    return rejectionPatterns.some(pattern =>
        errorMessage.includes(pattern) ||
        String(errorCode).includes(pattern)
    );
};